/**
 * Remove accents from a given string
 *
 * @param value - The input string from which accents need to be removed
 * @returns {string}
 * @example```js
 * const text = "Café";
 *
 * stripAccents(text) // cafe
 *```
 */
export function stripAccents(value) {
  if ("normalize" in String.prototype) {
    return String(value)
      .normalize("NFD")
      .replace(/[\u0300-\u036F]/g, "")
      .toLowerCase();
  }

  value = value.toLowerCase();
  value = value.replace(/\s/g, "");
  value = value.replace(/[àáâãäå]/g, "a");
  value = value.replace(/æ/g, "ae");
  value = value.replace(/ç/g, "c");
  value = value.replace(/[èéêë]/g, "e");
  value = value.replace(/[ìíîï]/g, "i");
  value = value.replace(/ñ/g, "n");
  value = value.replace(/[òóôõö]/g, "o");
  value = value.replace(/œ/g, "oe");
  value = value.replace(/[ùúûü]/g, "u");
  value = value.replace(/[ýÿ]/g, "y");
  value = value.replace(/\W/g, "");

  return value;
}

export function getFirstLetter(value = "") {
  if (!value) return "";
  return value.substring(0, 1);
}

export function getInitialChar(name = "") {
  const nameParts = name.trim().split(/\s+/).filter(Boolean);

  if (!nameParts.length) return;

  const firstInitial = nameParts[0].charAt(0).toUpperCase();
  const lastInitial =
    nameParts.length === 1
      ? nameParts[0].charAt(1).toUpperCase()
      : nameParts.at(-1)?.charAt(0).toUpperCase();

  return [firstInitial, lastInitial].filter(Boolean).join("");
}

export function toDigits(value) {
  return String(value).replace(/\D/g, "");
}

export function capitalize(value = "") {
  const text = String(value);
  const firstLetter = text[0].toUpperCase();
  const restText = text.substring(1);

  return `${firstLetter}${restText}`;
}

export function toUpper(value = "") {
  return String(value).toUpperCase();
}

export function toLower(value = "") {
  return String(value).toLowerCase();
}
